export const CONTENT_MANAGEMENT_STEP_BREADCRUMBS: Record<string, string> = {
  'estate-newsletter': 'Estate Newsletter',
};

export const POST_TYPE_UPDATE_BREADCRUMBS: Record<string, string> = {
  NEWSLETTER: 'Update Estate Newsletter',
};

export function getCreatePostBreadcrumb(step?: string): string {
  const key = step || '';
  return CONTENT_MANAGEMENT_STEP_BREADCRUMBS[key] || 'Create Post';
}

export function getUpdatePostBreadcrumb(postType?: string): string {
  const key = postType || '';
  return POST_TYPE_UPDATE_BREADCRUMBS[key] || 'Update Post';
}



// WEBPACK FOOTER //
// ./src/utils/contentManagementBreadcrumbs.ts